<mat-toolbar color="primary">Tyro Health Integration</mat-toolbar>

<mat-dialog-content>
  @if (integration$ | async; as integration) {
    <div class="flex flex-col items-start gap-4">
      <div class="flex gap-4">
        <strong>API Key:</strong>
        <span>{{ integration.data.apiKey }}</span>
      </div>

      <button mat-stroked-button (click)="removeIntegration()">
        Remove Tyro Health Integration
      </button>
    </div>
  } @else {
    <div class="medipass-button" (click)="addIntegration()">
      <img alt="Add to Tyro Health" [src]="config.medipassLogoUrl" />
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button mat-stroked-button type="button" mat-dialog-close>Close</button>
  </pt-buttons-container>
</mat-dialog-actions>
